import { render, staticRenderFns } from "./ChannelsSubscription.vue?vue&type=template&id=7e7419b5&"
import script from "./ChannelsSubscription.vue?vue&type=script&lang=js&"
export * from "./ChannelsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports